import React from 'react';
import classNames from 'classnames';
import { DEVICE_STATE, CAMERA_STATUS } from './constants';
import { Icons } from '../../components/base/BootstrapComponents';
import { PARKING_METER_STATUS, PRINTER_STATE } from '../ParkingMeter/constants';

import { getMetricValue } from '../ParkingMeter/parking-meter-utils';

export const sortByStatus = (a, b) => {
  if (a.status < b.status) {
    return -1;
  }
  if (a.status > b.status) {
    return 1;
  }
  return 0;
};

export const processingFormatter = (processing = {}) => {
  const processingValue = processing.find(e => e.metric_key === 'PROCESSING').value;
  const isUnknown = Number(processingValue);
  return (
    <div className={classNames('processing-formatter', { processing: processingValue === '2', unknown: !isUnknown })}>
      <Icons customIcon icon={!isUnknown ? 'processing-unknown' : 'processing'} className={classNames('processing-icons', { unknown: !isUnknown })} />
      {isUnknown ? <div className="processing-text ">{processing[2] && processing[2].value === '2' ? 'on' : 'off'}</div> : null}
    </div>
  );
};

export const getVersionStatus = metrics => {
  const appVersion = getMetricValue(metrics)('APP_VERSION');
  return { status: CAMERA_STATUS.UNKNOWN, statusText: appVersion };
};

export const getCameraStatus = metrics => {
  const deviceState = Number(getMetricValue(metrics)('DEVICE_STATE'));
  let data = { status: PARKING_METER_STATUS.WARNING, statusText: 'Нет данных' };
  if (deviceState === DEVICE_STATE.OK) {
    data = { status: DEVICE_STATE.OK, statusText: 'В работе' };
  }
  if (deviceState === DEVICE_STATE.NO_INIT_DETECT_VIOLATION) {
    data = { status: DEVICE_STATE.NO_INIT_CAMERA, statusText: 'Обнаружение нарушений отключено' };
  }
  if (deviceState === DEVICE_STATE.NO_INIT_DETECTION) {
    data = { status: DEVICE_STATE.NO_INIT_CAMERA, statusText: 'Детектирование отключено' };
  }
  if (deviceState === DEVICE_STATE.NO_INIT_CAMERA) {
    data = { status: DEVICE_STATE.NO_INIT_CAMERA, statusText: 'Видеокамера отключена' };
  }
  if (deviceState === DEVICE_STATE.UNKNOWN) {
    data = { status: DEVICE_STATE.UNKNOWN, statusText: 'Нет данных' };
  }
  if (deviceState === DEVICE_STATE.ERROR) {
    data = { status: DEVICE_STATE.ERROR, statusText: 'Ошибка' };
  }
  return data;
};

export const convertMetricFilters = filterData => {
  const filterConfig = {
    DEVICE_STATE: {
      DS_ERROR: -99,
      DS_NO_INIT_DETECT_VIOLATION: -3,
      DS_NO_INIT_DETECTION: -2,
      DS_NO_INIT_CAMERA: -1,
      DS_UNKNOWN: 0,
      DS_OK: 1,
    },
    PROCESSING: {
      PRS_UNKNOWN: 0,
      PRS_NO: 1,
      PRS_YES: 2,
    },
  };

  const metrics = {};
  const keys = Object.keys(filterConfig);
  for (let i = 0, len = keys.length; i < len; i++) {
    const key = keys[i];
    const options = filterConfig[key];
    const optionsKeys = Object.keys(options);
    const values = [];
    for (let j = 0, len2 = optionsKeys.length; j < len2; j++) {
      const optionName = optionsKeys[j];
      if (filterData && filterData[optionName]) {
        values.push(options[optionName]);
      }
      delete filterData[optionName];
    }
    if (values && values.length) {
      metrics[key] = values;
    }
  }
  if (Object.keys(metrics).length) {
    filterData.metrics = metrics;
  }
  return filterData;
};

export function getCheckClassByName(name) {
  const errorKeys = [
    'DS_ERROR',
    'PRS_NO',
  ];
  const warningKeys = [
    'PRS_UNKNOWN',
    'DS_UNKNOWN',
    'DS_NO_INIT_CAMERA',
    'DS_NO_INIT_DETECTION',
    'DS_NO_INIT_DETECT_VIOLATION',
  ];
  if (errorKeys.includes(name)) {
    return 'error-checkbox';
  }
  if (warningKeys.includes(name)) {
    return 'warning-checkbox';
  }
  return 'ok-checkbox';
}
